<div class="zn-form" [formGroup]="form">
    <fieldset>
        <div class="row">
            <div class="col-12">
                <div class="form-control-container">
                    <label class="form-label" for="MeditionNumber">
                        {{`${measurementLabelKey}`| abpLocalization}}
                        <span class="form-label-required">*</span>
                    </label>
                    <zn-single-select
                      id="MeditionNumber"
                      [options]="measurementOptions()"
                      [optionsLoader]="meditionNumbers"
                      [showSearch]="true"
                      formControlName="MeditionNumber"
                      [errorEntityKey]="measurementLabelKey"
                      [localizationResource]="localizationResource"
                      [openUp]="false"
                    >
                    </zn-single-select>
                    @if (fieldInvalidFunction('MeditionNumber')){
                        @if(form.get('MeditionNumber')?.hasError('required')){
                            <small class="invalid-feedback d-block">{{`LanguageService::DefaultErrorRequired` | abpLocalization}}</small>
                        }
                    }
                </div>
            </div>
        </div>
    </fieldset>
</div>
